import React, { useState } from "react";
import { Menu, Modal } from "antd";
import "./Slider.scss";
import { useNavigate } from "react-router-dom";
import {
  AppstoreOutlined,
  DisconnectOutlined,
  ShoppingOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { SubMenu } = Menu;

const SliderApp = ({ selectedKey, onClick }: any) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();
  const handleMenuClick = ({ key }: any) => {
    onClick(key);
    navigate(`/${key}`);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    localStorage.removeItem("token");
    window.location.href = "/sign-in";
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <Menu
      theme="light"
      mode="inline"
      defaultSelectedKeys={["1"]}
      onClick={handleMenuClick}
      className="sliderApp"
    >
      <SubMenu
        key="sub1"
        style={{ background: "none" }}
        icon={<AppstoreOutlined />}
        title={t("layout.home.home")}
      >
        <Menu.Item key="Home/Title" className="menuitemSub">
          {t("layout.home.banner")}
        </Menu.Item>
        <Menu.Item key="Home/Policy" className="menuitemSub">
          Chính sách
        </Menu.Item>
         <Menu.Item key="Home/Standing" className="menuitemSub">
          Nổi bật
        </Menu.Item>
         <Menu.Item key="Home/Origin" className="menuitemSub">
          Nguồn hàng
        </Menu.Item>
        <Menu.Item key="Home/WhyChoose" className="menuitemSub">
          Lý do
        </Menu.Item>
         <Menu.Item key="Home/Collection" className="menuitemSub">
         Bộ sưu tập
        </Menu.Item>
        <Menu.Item key="Home/Other" className="menuitemSub">
         Dịch vụ khác
        </Menu.Item>
      </SubMenu>

       <SubMenu
        key="sub2"
        style={{ background: "none" }}
        icon={<UnorderedListOutlined />}
        title={"Danh mục"}
      >
        <Menu.Item key="Category/Data" className="menuitemSub">
          Danh sách
        </Menu.Item>
        <Menu.Item key="Category/Banner" className="menuitemSub">
          Banner
        </Menu.Item>
        

        <Menu.Item key="Category/Today" className="menuitemSub">
          Đề xuất hôm nay
        </Menu.Item>
        <Menu.Item key="Category/BestSale" className="menuitemSub">
          Bán chạy
        </Menu.Item>
        <Menu.Item key="Category/Discover" className="menuitemSub">
          Khám phá
        </Menu.Item>
        <Menu.Item key="Category/TopTrend" className="menuitemSub">
          Top xu hướng
        </Menu.Item>
         <Menu.Item key="Category/Policy" className="menuitemSub">
          Chính sách
        </Menu.Item>
      </SubMenu>

       <SubMenu
        key="sub3"
        style={{ background: "none" }}
        icon={<ShoppingOutlined />}
        title={"Sản phẩm"}
      >
         <Menu.Item key="Product/Banner" className="menuitemSub">
          Banner
        </Menu.Item>
        <Menu.Item key="Product/Data">
        Sản phẩm
      </Menu.Item>
       
      </SubMenu>
       <Menu.Item
        icon={<DisconnectOutlined />}
        key="contact"
      >
       Liên hệ
      </Menu.Item>
      <Menu.Item
        icon={<DisconnectOutlined />}
        key="Sign-out"
        onClick={showModal}
      >
        Đăng xuất
      </Menu.Item>
      <Modal
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        width={340}
      >
        <h3 style={{ textAlign: "center", fontSize: 24 }}>Đăng xuất</h3>
        <p style={{ textAlign: "center", fontSize: 16 }}>
          Bạn có chắc chắn đăng xuất?
        </p>
      </Modal>
    </Menu>
  );
};

export default SliderApp;
